export default __webpack_public_path__ + "static/media/WS.b9271c9c.svg";